import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmdbRegisterPageLogsComponent } from './cmdb-register-page-logs.component';

@NgModule({
	declarations: [],
	imports: [CmdbRegisterPageLogsComponent],
	exports: [CmdbRegisterPageLogsComponent],
})
export class CmdbRegisterPageLogsModule {}
